import React from 'react';
// import { BrowserRouter as Router, Route} from "react-router-dom";

import createHistory from 'history/createHashHistory';
import { Route, HashRouter as Router } from 'react-router-dom';
import AdminIndex from './AdminIndex';
import Login from './Login';
const history = createHistory()
function Main(props) {

    return (
        <Router basename={'/public/build'}>
            <Route path="/" exact component={AdminIndex} />
            <Route path="/index/" component={AdminIndex} />
            <Route path="/ad/" component={AdminIndex} />
            <Route path="/banner/" component={AdminIndex} />
            <Route path="/news/" component={AdminIndex} />
            <Route path="/notice/" component={AdminIndex} />
            <Route path="/feedbackList/" component={AdminIndex} />
            <Route path="/surfspotgeo/" component={AdminIndex} />
            <Route path="/login" component={Login} />
        </Router>
    )
}

export default Main